import { render, staticRenderFns } from "./DocumentCreditInquiry.vue?vue&type=template&id=47ca82e6&scoped=true&"
import script from "./DocumentCreditInquiry.vue?vue&type=script&lang=js&"
export * from "./DocumentCreditInquiry.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCreditInquiry.vue?vue&type=style&index=0&id=47ca82e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca82e6",
  null
  
)

export default component.exports